import styled from 'styled-components';
import HeightIcon from '@material-ui/icons/Height';
import LineChartNivo from './LineChartNivo';
import { useGetTextParameter } from '../../../helpers/hooks';
import { kassimGreen, makeTransparent } from '../../../style/theme';
import { ContentPaper } from '../styled';

const InnerContainer = styled.div`
    display: flex;
    height: 100%;
    position: relative;
`;

const ChartButton = styled.div`
    position: absolute;
    top: 0px;
    right: 4px;
    cursor: pointer;
    z-index: 100;
    border: 1px solid ${makeTransparent(kassimGreen, 0.8)};
    border-radius: 4px;
    color: #1d5f1d;

    &:hover {
        background-color: ${makeTransparent(kassimGreen, 0.2)};
        border-color: ${makeTransparent(kassimGreen, 0.4)};
    }

    & svg {
        display: block;
        font-size: 28px;
    }
`;

const OpenPopupIcon = styled(HeightIcon)`
    & path {
        transform-origin: center center;
        transform: rotate(-45deg);
    }

    &:nth-child(2) path {
        transform: rotate(45deg);
    }

    &:nth-child(2) {
        position: absolute;
        top: 0;
        left: 0;
    }
`;
const OpenPopupButton = styled(ChartButton)`
    left: 0px;
    right: auto;

    & svg {
        font-size: 20px;
    }
`;

const ChartContainer = styled.div`
    height: ${({ $height }) => $height};
    flex: 1;
    position: relative;
    min-width: 0;
`;

const ChartPanel = ({
    data,
    chartHeight = '200px',
    openPopup,
    title,
    className,
    helpUrl,
}) => {
    const getTextParameter = useGetTextParameter();

    const { style, y1name, x1, y1, y2name, x2, y2, xlabel, ylabel } = data;
    let nivoData = [];

    if (data) {
        nivoData = [
            {
                id: getTextParameter(y1name),
                data: x1?.map((xData, i) => {
                    return {
                        x: xData,
                        y: y1?.[i],
                    };
                }),
            },
            {
                id: getTextParameter(y2name),
                data: x2?.map((xData, i) => {
                    return {
                        x: xData,
                        y: y2?.[i],
                    };
                }),
            },
        ];
    } else {
        nivoData = [];
    }

    return (
        <ContentPaper className={className} helpUrl={helpUrl}>
            <InnerContainer>
                <ChartContainer $height={chartHeight}>
                    <LineChartNivo
                        data={nivoData}
                        title={title}
                        enableArea={false}
                        yScaleMin="auto"
                        normalise={false}
                        xLabel={xlabel}
                        yLabel={ylabel}
                        // xScaleMin={0}
                        chartStyle={style}
                    />
                </ChartContainer>

                {openPopup && (
                    <OpenPopupButton onClick={openPopup}>
                        <OpenPopupIcon />
                        <OpenPopupIcon />
                    </OpenPopupButton>
                )}
            </InnerContainer>
        </ContentPaper>
    );
};

export default ChartPanel;
